module.exports = __webpack_public_path__ + "static/Reed-02276d4ef1102fd21e635fcecd379909.webp";